import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden', // Changed from 'auto' to 'hidden'
  },
  header: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: 'white',
    padding: theme.spacing(4, 4, 2, 4),
    marginBottom: 0,
    borderBottom: `2px solid rgba(0, 168, 255, 0.1)`,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    // Tablet adjustments
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3, 3, 2, 3),
    },
    // Mobile adjustments
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2, 2, 1.5, 2),
    },
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(3),
    // Mobile: stack vertically
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing(2),
    },
  },
  headerInfo: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    flex: 1,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
    flexWrap: 'wrap',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexShrink: 0,
    // Small screens: stack buttons vertically and full width
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      justifyContent: 'center',
      '& .MuiButton-root': {
        width: '100%',
        padding: theme.spacing(1, 2),
        fontSize: '0.875rem',
      },
    },
  },
  title: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: '#1976d2',
    marginBottom: theme.spacing(0.5),
  },
  subtitle: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
  scrollableContent: {
    flex: 1,
    overflow: 'auto',
    padding: theme.spacing(4),
    paddingTop: theme.spacing(3),
    position: 'relative',
    // Tablet adjustments
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3),
      paddingTop: theme.spacing(2),
    },
    // Mobile adjustments
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(2),
    },
  },
  sectionArchived: {
    background: '#f5f5f5',
    opacity: 0.85,
    '& .MuiTextField-root': {
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#f5f5f5',
      },
    },
    '& .MuiTypography-root': {
      color: 'rgba(0, 0, 0, 0.6)',
    },
  },
  content: {
    flex: 1,
  },
  section: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
    background: '#ffffff',
    borderRadius: 12,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2.5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
      borderRadius: 8,
    },
  },
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: theme.colors?.blue2 || '#122056',
    marginBottom: theme.spacing(1.5),
    paddingBottom: theme.spacing(1),
    borderBottom: `2px solid ${theme.colors?.lightBlue || '#5B65DC'}`,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      marginBottom: theme.spacing(1),
    },
  },
  sectionContent: {
    marginTop: theme.spacing(2),
    maxWidth: 1000,
    width: '100%',
  },
  formGroup: {
    marginBottom: theme.spacing(4),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  groupTitle: {
    fontSize: '1rem',
    fontWeight: 500,
    color: theme.colors?.blue2 || '#122056',
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  groupContent: {
    paddingLeft: theme.spacing(2),
  },
  fullWidth: {
    width: '100%',
    maxWidth: 'none',
    marginTop: 0,
  },
  fieldGroup: {
    marginBottom: theme.spacing(3),
  },
  assessmentSelectorWrapper: {
    '& > div': {
      marginTop: theme.spacing(1),
      '&.disabled': {
        opacity: 0.6,
        pointerEvents: 'none',
      },
    },
  },
  statusIndicator: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: theme.spacing(0.25, 0.75),
    borderRadius: 12,
    fontSize: '0.65rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginLeft: theme.spacing(1),
    '&.draft': {
      backgroundColor: '#fff3cd',
      color: '#856404',
    },
    '&.active': {
      backgroundColor: '#d4edda',
      color: '#155724',
    },
    '&.completed': {
      backgroundColor: '#d1ecf1',
      color: '#0c5460',
    },
    '&.inactive': {
      backgroundColor: '#f8d7da',
      color: '#721c24',
    },
    '&.archived': {
      backgroundColor: '#e2e3e5',
      color: '#383d41',
    },
  },
  assessmentLabel: {
    fontSize: '0.75rem',
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.54)',
    marginBottom: theme.spacing(0.5),
    display: 'block',
  },
  switchControl: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(2),
    // marginBottom: theme.spacing(2),
    '& .MuiTypography-body1': {
      fontSize: '0.9375rem',
      fontWeight: 500,
      marginLeft: theme.spacing(1),
      color: theme.palette.text.primary,
    },
  },
  previewSection: {
    background: 'rgba(25, 118, 210, 0.02)',
    border: '1px solid rgba(25, 118, 210, 0.1)',
  },
  linkPreview: {
    backgroundColor: '#f8f9fa',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    borderRadius: 8,
    padding: theme.spacing(2),
    fontFamily: '"SF Mono", Monaco, Inconsolata, "Fira Code", monospace',
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    wordBreak: 'break-all',
    marginBottom: theme.spacing(2),
  },
  buttonGroup: {
    display: 'flex',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
    // Tablet adjustments
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
      gap: theme.spacing(0.5),
    },
    // Mobile adjustments
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1),
      '& > *': {
        width: '100%',
      },
    },
  },
  primaryButton: {
    textTransform: 'uppercase',
    borderRadius: 10,
    padding: theme.spacing(1.5, 3),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
    backgroundColor: '#5B65DC',
    color: 'white',
    '&:hover': {
      backgroundColor: '#0093E6',
    },
  },
  secondaryButton: {
    textTransform: 'uppercase',
    borderRadius: 10,
    padding: theme.spacing(1.5, 3),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
    color: '#5B65DC',
    borderColor: '#5B65DC',
    '&:hover': {
      backgroundColor: 'rgba(0, 168, 255, 0.04)',
      borderColor: '#0093E6',
    },
  },
  qrContainer: {
    width: 280,
    height: 280,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'white',
    borderRadius: 8,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    transition: 'all 0.3s ease',
    // Tablet adjustments
    [theme.breakpoints.down('md')]: {
      width: 240,
      height: 240,
    },
    // Mobile adjustments
    [theme.breakpoints.down('sm')]: {
      width: 150,
      height: 150,
    },
    // Archived state - make QR code slightly gray
    '&.archived': {
      filter: 'grayscale(100%) opacity(0.7)',
      backgroundColor: '#fafafa',
    },
  },
  qrSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5),
    },
  },
  downloadButton: {
    width: 48,
  },
  infoBox: {
    marginTop: theme.spacing(1),
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
  readOnlyField: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.5),
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    marginBottom: theme.spacing(1.5),
    minHeight: 48,
  },
  readOnlyLabel: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.54)',
    marginBottom: theme.spacing(0.25),
  },
  readOnlyValue: {
    fontSize: '0.9375rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  editButton: {
    padding: theme.spacing(1),
    minWidth: 36,
    width: 36,
    height: 36,
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.08)',
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(3),
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(6),
    color: theme.palette.text.secondary,
  },
  emptyTitle: {
    fontSize: '1.25rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1),
  },
  emptyText: {
    fontSize: '0.9375rem',
    color: theme.palette.text.secondary,
    maxWidth: 400,
    margin: '0 auto',
  },
  sectionDisabled: {
    opacity: 0.7,
    backgroundColor: '#fafafa',
    '& .MuiTextField-root': {
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#f5f5f5',
      },
    },
  },
  launchButton: {
    backgroundColor: '#4caf50',
    color: 'white',
    textTransform: 'uppercase',
    borderRadius: 10,
    padding: theme.spacing(1.5, 3),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
    '&:hover': {
      backgroundColor: '#45a049',
    },
  },
  deactivateButton: {
    backgroundColor: '#f44336',
    color: 'white',
    textTransform: 'uppercase',
    borderRadius: 10,
    padding: theme.spacing(1.5, 3),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
    '&:hover': {
      backgroundColor: '#d32f2f',
    },
  },
  relaunchButton: {
    backgroundColor: '#2196f3',
    color: 'white',
    textTransform: 'uppercase',
    borderRadius: 10,
    padding: theme.spacing(1.5, 3),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
    '&:hover': {
      backgroundColor: '#1976d2',
    },
  },
  deleteButton: {
    backgroundColor: '#9e9e9e',
    color: 'white',
    textTransform: 'uppercase',
    borderRadius: 10,
    padding: theme.spacing(1.5, 3),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
    '&:hover': {
      backgroundColor: '#757575',
    },
  },
  // Delete Modal Styles
  deleteModal: {
    width: 600,
    minWidth: 520,
    maxWidth: '90vw',
    height: 'auto',
    maxHeight: '80vh',
    borderRadius: 12,
    boxShadow: '0 24px 48px rgba(0, 0, 0, 0.12)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    alignItems: 'center',
  },
  deleteModalContent: {
    flex: 1,
    padding: theme.spacing(4, 6),
    background: 'linear-gradient(135deg, #fafafa 0%, #ffffff 100%)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  deleteWarningIcon: {
    fontSize: 64,
    color: '#f56565',
    marginBottom: theme.spacing(2),
    filter: 'drop-shadow(0 4px 8px rgba(245, 101, 101, 0.2))',
  },
  deleteModalTitle: {
    fontSize: 24,
    fontWeight: 600,
    color: '#2d3748',
    marginBottom: theme.spacing(2),
    lineHeight: 1.3,
  },
  deleteModalMessage: {
    fontSize: 16,
    color: '#4a5568',
    lineHeight: 1.6,
    marginBottom: theme.spacing(1),
    maxWidth: 450,
  },
  deleteWarningMessage: {
    fontSize: 14,
    color: '#e53e3e',
    fontWeight: 500,
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    background: 'rgba(245, 101, 101, 0.08)',
    borderRadius: 8,
    border: '1px solid rgba(245, 101, 101, 0.2)',
    maxWidth: 450,
  },
  deleteRecommendation: {
    fontSize: 14,
    color: '#2b6cb0',
    fontWeight: 500,
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    background: 'rgba(33, 150, 243, 0.08)',
    borderRadius: 8,
    border: '1px solid rgba(33, 150, 243, 0.2)',
    maxWidth: 450,
  },
  surveyNameHighlight: {
    fontWeight: 600,
    color: '#2b6cb0',
  },
  deleteModalActions: {
    padding: theme.spacing(3),
    background: '#ffffff',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '0 0 16px 16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexShrink: 0,
    boxShadow: '0 -4px 16px rgba(0, 0, 0, 0.08)',
    width: '100%',
  },
  deleteModalButton: {
    textTransform: 'uppercase',
    borderRadius: 10,
    padding: theme.spacing(1.5, 3),
    letterSpacing: 1.5,
    fontWeight: 600,
    fontSize: 14,
    minWidth: 100,
    height: 40,
  },
  deleteConfirmButton: {
    backgroundColor: '#dc3545',
    borderColor: '#dc3545',
    color: 'white',
    '&:hover': {
      backgroundColor: '#c82333',
      borderColor: '#bd2130',
    },
  },
  linkContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: `rgba(25, 118, 210, 0.08)`,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid rgba(25, 118, 210, 0.2)`,
    padding: theme.spacing(2, 4),
    marginBottom: theme.spacing(2),
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: `rgba(25, 118, 210, 0.12)`,
      borderColor: `rgba(25, 118, 210, 0.3)`,
    },
  },
  linkText: {
    flex: 1,
    fontSize: 14,
    fontFamily: 'monospace',
    color: theme.colors?.blue2 || '#122056',
    wordBreak: 'break-all',
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  linkCopyButton: {
    marginLeft: theme.spacing(4),
    padding: theme.spacing(0.5),
    color: theme.colors?.lightBlue || '#5B65DC',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: `rgba(25, 118, 210, 0.15)`,
      color: theme.colors?.blue5 || '#1976d2',
    },
  },
  linkCopyIcon: {
    width: 20,
    height: 20,
    [theme.breakpoints.down('xs')]: {
      width: 18,
      height: 18,
    },
  },
}));
